"use client";

import { useQuery } from "@tanstack/react-query";

type BlogTagsResponse = {
  tags: string[];
};

async function fetchBlogTags(): Promise<BlogTagsResponse> {
  const res = await fetch("/api/blog/tags", {
    credentials: "include",
  });

  if (!res.ok) {
    throw new Error("Failed to fetch blog tags");
  }

  return res.json();
}

export function useBlogTags() {
  return useQuery({
    queryKey: ["blog-tags"],
    queryFn: fetchBlogTags,
    staleTime: 60_000,
  });
}
